import {devLog} from "../../../../utils/devLog/devLog";
import axios from "axios";

export default async(skill: string, language: string) => {
  try {
    
    await axios.post(`${process.env.REACT_APP_API_URL}/data/skill`, {skill, language
    }, {withCredentials: true});
  
  } catch(error) {
    
    devLog(error);
  }
}